import {Badge} from "@shopify/polaris";

export const OrderPaymentStatusBadge = ({order}) => {
    const getStatus = () => {
        if (order.financial_status == 'pending' && order.processing_count > 0) {
            return getRow('Processing', 'info', 'partiallyComplete');
        }

        if (order.financial_status == 'pending' && order.failed_count > 0) {
            return getRow(`Failed payments: ${order.failed_count}`, 'critical', 'incomplete');
        }

        if (order.financial_status == 'authorized') {
            return getRow('Authorized', 'warning', 'incomplete');
        } else if (order.financial_status == 'partially_paid') {
            return getRow('Partially paid', 'attention', 'partiallyComplete');
        } else if (order.financial_status == 'paid') {
            return getRow('Paid', null, 'complete');
        }else if (order.financial_status == 'partially_refunded') {
            return getRow('Partially refunded', null, 'partiallyComplete');
        } else if (order.financial_status == 'refunded') {
            return getRow('Refunded', null, 'complete');
        } else if (order.financial_status == 'voided') {
            return getRow('Voided', null, 'complete');
        }

        return getRow('Payment pending', 'attention', 'incomplete');
    }

    const getRow  = (name, tone = null, progress = null) => {
        return {name, tone, progress};
    }

    const internalStatus = getStatus();

    return (<Badge tone={internalStatus.tone} progress={internalStatus.progress}>{internalStatus.name}</Badge>);
}
